function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import Honeybadger from '@honeybadger-io/js';
export { default as Honeybadger } from '@honeybadger-io/js';
import React, { Component } from 'react';
// eslint-disable-next-line @typescript-eslint/ban-types
class DefaultErrorComponent extends Component {
  render() {
    return /*#__PURE__*/React.createElement("div", {
      className: 'error'
    }, /*#__PURE__*/React.createElement("div", null, "An Error Occurred"), /*#__PURE__*/React.createElement("div", null, JSON.stringify(this.props.error, null, 2)), /*#__PURE__*/React.createElement("div", null, this.props.info ? JSON.stringify(this.props.info, null, 2) : ''));
  }
}
class HoneybadgerErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = {
      error: null,
      info: null,
      errorOccurred: false
    };
    this.props.honeybadger.afterNotify((error, _notice) => {
      if (!error && this.props.showUserFeedbackFormOnError) {
        this.props.honeybadger.showUserFeedbackForm();
      }
    });
  }
  static getDerivedStateFromError(error) {
    return {
      error: error,
      errorOccurred: true,
      info: null
    };
  }
  componentDidCatch(error, errorInfo) {
    this.setState({
      errorOccurred: true,
      error: error,
      info: errorInfo
    });
    this.props.honeybadger.notify(error, {
      context: errorInfo
    });
  }
  getErrorComponent() {
    return this.props.ErrorComponent ? /*#__PURE__*/React.createElement(this.props.ErrorComponent, this.state) : /*#__PURE__*/React.createElement(DefaultErrorComponent, _objectSpread({}, this.state));
  }
  render() {
    return /*#__PURE__*/React.createElement(React.Fragment, null, this.state.errorOccurred ? this.getErrorComponent() : this.props.children);
  }
}
HoneybadgerErrorBoundary.defaultProps = {
  showUserFeedbackFormOnError: false
};
const NOTIFIER = {
  name: '@honeybadger-io/react',
  url: 'https://github.com/honeybadger-io/honeybadger-js/tree/master/packages/react',
  version: '6.1.21'
};
Honeybadger.setNotifier(NOTIFIER);
export { HoneybadgerErrorBoundary };